"use strict";

export const accordion = function() {

    let options;

    const init = function(selector, user_options) {
		// Defaults	
		let defaults = {
			header_class: 'Accordion__header__button'
		};

		options = extendDefaults(defaults, user_options);

        const containers = document.querySelectorAll( selector );

        // For each Accordion group...
        Array.prototype.forEach.call( containers, function(el) {
            let headers = el.querySelectorAll('.' + options.header_class);
            Array.prototype.forEach.call( headers, function(el) {
                let trigger = el, 
                    target = document.getElementById(trigger.getAttribute('aria-controls'));
                trigger.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    toggleElement(trigger, target);
                }, false);
            });
        });

        // Window resize
        window.addEventListener('resize', () => {
            clearTimeout(window.resizeTimer);
            window.resizeTimer = setTimeout(() => {
                Array.prototype.forEach.call( containers, function(el) {
                    let headers = el.querySelectorAll('.' + options.header_class);
                    Array.prototype.forEach.call( headers, function() {
                        changeHeight( document.getElementById(trigger.getAttribute('aria-controls')) );
                    });
                });
            }, 100);	
        });
    };

	/* 
		Change element height, when window is resized and when element is active
		el = all elements [object]
	*/
	function changeHeight(element) {
        if( element.getAttribute('aria-hidden') == 'false' ) {
            element.style.height = "auto";
            let height = element.offsetHeight;
            element.style.height = height + 'px';
        }
	}

	/* 
		Toggle current element
		element = current element [object]
	*/
	function toggleElement(trigger, target) {
        if (trigger.getAttribute('aria-expanded') == 'true') {
            trigger.setAttribute('aria-expanded', 'false');
            target.setAttribute('aria-hidden', 'true');
			target.style.height = 0;
        } else {
            trigger.setAttribute('aria-expanded', 'true');
            target.setAttribute('aria-hidden', 'false');
			target.style.height = 'auto';

            // setting to 0 and then to absolute px height a tiny bit later is necessary for css animation to kick in
			let height = target.offsetHeight;
			target.style.height = 0;
            setTimeout( () => {
                target.style.height = height + 'px';
            }, 10);
        }
	}

	/* 
		Extend defaults
		defaults = defaults options defined in script [object]
		properties = options defined by user [object]
	*/
	function extendDefaults(defaults, properties) {
		if (properties != null && properties != undefined && properties != 'undefined') {
			for (let property in properties) {
				defaults[property] = properties[property];
            }
		}
		return defaults;
	}

    return { init };

}();